// extracted by mini-css-extract-plugin
export default {"status":"PaymentStatusTitle_status__BXWrK","status_success":"PaymentStatusTitle_status_success__fdefm"};